export default "__VITE_ASSET__BKKbtamU__"